import React, { useRef, useEffect } from "react";
const searchIcon = require("../images/search-icon.svg");
const whiteRightArrowIcon = require("../images/white-right-arrow.svg");

const PhotographerSearch = ({
  name,
  updateName
}: {
  name: string;
  updateName: (name: string) => void;
}) => {
  const inputRef: any = React.createRef();

  useEffect(() => {
    const setupKeywordsAutosuggest = () => {
      // @ts-ignore
      $("#search-photographer").soulmate({
        url: "/search/search",
        types: ["users"],
        renderCallback: (term: string, data: any, type: "users") => {
          return term;
        },
        selectCallback: (term: string, data: any, type: "users") => {
          window.open(data.link, '_blank');
        },
        filterCallback: (result: any, type: "users") => {
          return true;
        },
        minQueryLength: 1,
        maxResults: "",
        timeout: 2000
      });
    };

    setupKeywordsAutosuggest();
  }, []);

  return (
    <div className="tab-pane fade active in" id="tab-keywords">
      <label htmlFor="search-photos" className="search-bar flex-row">
        <span className="search-label">
          <img src={searchIcon} alt="" />
        </span>
        <input
          id="search-photographer"
          type="text"
          className="search-field"
          placeholder="Search to find a Photographer"
          ref={inputRef}
          defaultValue={name}
          onKeyDown={e => {
            if (e.key === "Enter") {
              // @ts-ignore
              $("ul#soulmate").hide();
              updateName(inputRef.current.value);
            }
          }}
        />
        <button
          type="submit"
          className="btn secondary-btn key-btn"
          onClick={() => updateName(inputRef.current.value)}
        >
          <img src={whiteRightArrowIcon} alt="" />
        </button>
      </label>
    </div>
  );
};

export default PhotographerSearch;
